import React from "react";
import { Input, ConfigProvider } from "antd";

const { TextArea } = Input;

const TextAreaField = ({
  rows = 3,
  placeholder = "",
  value,
  disabled = false,
  onChange,
  onBlur,
  onFocus,
  style = {},
  className = "",
  hoverBorder = false,
  ...rest
}) => {
  return (
    <ConfigProvider
      theme={{
        components: {
          Input: {
            paddingBlock: 6,
            borderRadius: 4,
            colorBgContainer: "rgba(0,0,0,0.04)",
            borderColor: "transparent",
            colorBorder: "transparent",
            controlOutline: "none",
            activeShadow: "none",
          },
        },
      }}
    >
      <TextArea
        rows={rows}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={onChange}
        onBlur={onBlur}
        onFocus={onFocus}
        style={{
          width: "100%",
          resize: "none", // Optional: disable manual resizing
          ...style,
        }}
        className={`${hoverBorder ? "custom-input-hover" : ""} ${className}`}
        {...rest}
      />
    </ConfigProvider>
  );
};

export default TextAreaField;
